




























































import Vue from 'vue';
import moment from 'moment-timezone';
import _ from 'lodash';

import { Consulta } from '../../../../back/src/entity/Consulta';

export default Vue.extend({
  name: 'TheConsultasTabelaEmAndamento',
  props: {
    consultas: {
      type: Array as () => Consulta[],
    },
  },
  data() {
    return {
    };
  },
  computed: {
    headers() {
      return [
        {
          value: 'started',
          text: 'Iniciada em',
          sortable: true,
          class: 'text-no-wrap',
        },
        {
          value: 'usuario_started_by',
          text: 'Iniciada por',
          sortable: false,
          class: 'text-no-wrap',
          align: 'center',
        },
        {
          value: 'consulta_coletiva_id',
          text: 'Coletiva',
          sortable: false,
          class: 'text-no-wrap',
          align: 'center',
        },
        {
          value: 'actions',
          text: 'Atender',
          sortable: false,
          class: 'text-no-wrap',
          align: 'right',
        },
      ];
    },
  },
  methods: {
    linkConsultasAtender(consultaId: number) {
      return {
        name: 'ConsultasAtender',
        params: { consultaId },
      };
    },
    linkConsultaColetiva(consultaColetivaId: number) {
      return {
        name: 'ConsultaColetivaAtiva',
        params: { consultaColetivaId },
      };
    },
  },
});
